import keykey from 'keykey';

const constants = keykey(
  'LIBRARY_LOAD_TEXT_GROUP_LIST',
  'LIBRARY_LOAD_WORK_LIST',
  'LIBRARY_FILTER_WORKS',
  'LIBRARY_RESET_WORKS',
  'LIBRARY_LOAD_VERSION_LIST',
  'LIBRARY_LOAD_TOC_LIST',
  'LIBRARY_FILTER_TEXT_GROUPS',
  'LIBRARY_RESET_TEXT_GROUPS',
  'LIBRARY_FILTER_TEXT_GROUP_WORKS',
  'LIBRARY_RESET_TEXT_GROUP_WORKS',
  'CLEAR_ANNOTATION',
  'CLEAR_ANNOTATIONS',
  'SET_TEXT_GROUPS',
  'SET_TEXT_GROUP_URNS',
  'SET_WORKS',
  'SET_VERSIONS',
  'SET_TOC',
  'SET_LIBRARY_SORT',
  'SET_ERROR',
  'SET_HIGHLIGHT',
  'SET_LEFT_TEXT',
  'SET_LEFT_PASSAGE_TEXT',
  'SET_LEFT_PASSAGE',
  'SET_RIGHT_TEXT',
  'SET_RIGHT_PASSAGE_TEXT',
  'SET_RIGHT_PASSAGE',
  'SET_PARALLEL_TEXT',
  'SET_PARALLEL_PASSAGE_TEXT',
  'SET_PARALLEL_PASSAGE',
  'SET_LOWER_TEXT',
  'SET_AVAILABLE_REFS',
  'SET_SELECTED_REF_RANGE',
  'SET_LOWER_PASSAGE_TEXT',
  'SET_LOWER_PASSAGE',
  'SET_SELECTED_TOKEN_RANGE',
  'SET_TEXT_MODE',
  'SET_TEXT_MODE_PANE',
  'READER_LOAD',
  'SET_ANNOTATION',
  'SET_ANNOTATIONS',
  'READER_SET_SELECTED_REF',
  'READER_SELECT_REF_RANGE',
  'READER_SET_SELECTED_TOKEN',
  'READER_SELECT_TOKEN_RANGE',
  'READER_HIGHLIGHT',
  'READER_TEXT_MODE_PANE',
  'READER_TOGGLE_SIDEBAR_LEFT',
  'READER_TOGGLE_SIDEBAR_RIGHT',
  'READER_SET_SELECTED_LEMMAS',
);

constants.PRODUCT_LABEL = 'Publication';
constants.PRODUCT_LABEL_PLURAL = 'Publications';

export default constants;
